import {
  CreditCardType,
  Network
} from '@vio/core/src/api-types/bovio/request/booking_creation'
import {Code as CardCode} from '@vio/core/src/api-types/bovio/response/payment_methods_settings'

export const acceptedCardTypes: CardCode[] = [
  CardCode.Vi,
  CardCode.CA,
  CardCode.Ax,
  CardCode.Cu,
  CardCode.Dc,
  CardCode.Ds,
  CardCode.Jc,
  CardCode.To
]

export const secureFieldsToBofhTypes: Record<string, CardCode> = {
  VIS: CardCode.Vi,
  ECA: CardCode.CA,
  AMX: CardCode.Ax,
  DIN: CardCode.Dc,
  DIS: CardCode.Ds,
  JCB: CardCode.Jc,
  CUP: CardCode.Cu,
  MAU: CardCode.To
}

/**
 * CoBrand represents payment providers that handle user transactions.
 * EU regulations require users to choose the network for processing payments.
 */
export enum CoBrandCardType {
  CBL = 'CBL' // French payment network Cartes Bancaires
}

/**
 * Maps credit and CoBrand card types to the network type expected by our API.
 * Used for the dropdown menu to select the payment network.
 */
export const cardTypeToNetwork = {
  [CoBrandCardType.CBL]: Network.CartesBancaires,
  [CreditCardType.Vi]: Network.Visa,
  [CreditCardType.CA]: Network.MasterCard
}
